import { Injectable } from '@angular/core';
import { BaseService } from '../alcance/services/_base.service';
import { TipoMotivoDBService } from '../database/tipo-motivo-db.service';

@Injectable({
  providedIn: 'root'
})
export class TipoMotivoService extends BaseService{
    override classname: string = 'TipoMotivoService';
    public override route: string = 'tipo-motivo';
    public override database = new TipoMotivoDBService();
}
